import { useRentalManagerUserPropertyListWebApiHandler_list } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import type { QueryKey } from '@zg-rentals/react-query5';

export interface PropertyListing {
  listingAlias: string;
  fullAddress: string;
  propertyTypeCode: number;
  unitNumber?: string;
}

export interface GetPropertiesResponse {
  listings: Array<PropertyListing>;
}

export const getPropertiesQueryKey = (): QueryKey =>
  useRentalManagerUserPropertyListWebApiHandler_list.getKey({}) as QueryKey;

export function useGetProperties(options?: { enabled?: boolean }) {
  return useRentalManagerUserPropertyListWebApiHandler_list(
    {},
    {
      enabled: options?.enabled !== false,
    },
  );
}
